import './app.css'
import {BrowserRouter as Router,Route} from 'react-router-dom'
import Home from './pages/Home'
import Main from './pages/Main'
function App(){
    return (
        <Router>
            <Route  path="/main" component={Main} />
            <Route exact path="/" component={Home} />
        </Router>
    )
}

export default App